import React, { useEffect } from 'react';
import { Colors } from './form_builder.js';
import { useTranslation } from 'react-i18next';
import * as menu from "../../../assets/menus/menu.js";

/**
 * Component to edit a multilingual text array (e.g., [{ language: "en", text: "..." }, ...])
 * 
 * @param {string} language - The current language (ISO alpha-2)
 * @param {string} mode - 'input' or 'textarea'
 * @param {Array} text - The multilingual array [{ language, text }]
 * @param {function} onChange - Callback to update the entire array
 */
const Language_Text_Editor = ({ 
  language, 
  mode = "input", 
  text = [], 
  onChange,
  colors = Colors
}) => {
  const { t } = useTranslation();

  // Labels are now managed centrally in menu.js via form_builder_labels.js
  // No need to set up individual labels here as they are loaded automatically

  // Find the current language entry
  const current = text.find(entry => entry.language === language) || { language, text: '' };

  // Handle input changes and update the entire array
  const handleChange = (e) => {
    const newText = e.target.value;
    const updated = text.map(entry =>
      entry.language === language ? { ...entry, text: newText } : entry
    );

    // If no existing entry for the current language, add it
    if (!text.some(entry => entry.language === language)) {
      updated.push({ language, text: newText });
    }

    onChange(updated);
  };

  // Get language flag emoji
  const getLanguageFlag = (lang) => {
    switch(lang.toLowerCase()) {
      case 'en': return '🇬🇧';
      case 'it': return '🇮🇹';
      default: return '';
    }
  };

  // Get language name
  const getLanguageName = (lang) => {
    switch(lang.toLowerCase()) {
      case 'en': return t('english', { ns: 'labels' });
      case 'it': return t('italian', { ns: 'labels' });
      default: return lang;
    }
  };

  const languageIndicator = (
    <div className="input-group-text" style={{ backgroundColor: colors.secondaryLight }}>
      <span title={getLanguageName(language)}>
        {getLanguageFlag(language)}
      </span>
    </div>
  );

  return mode === 'textarea' ? (
    <div className="input-group w-100">
      {languageIndicator}
      <textarea
        className="form-control"
        rows={3}
        value={current.text}
        onChange={handleChange}
        placeholder={`${t('enterTextIn', { ns: 'labels' })} ${getLanguageName(language)}`}
        style={{ borderColor: colors.secondaryLight }}
      />
    </div>
  ) : (
    <div className="input-group w-100">
      {languageIndicator}
      <input
        type="text"
        className="form-control"
        value={current.text}
        onChange={handleChange}
        placeholder={`${t('enterTextIn', { ns: 'labels' })} ${getLanguageName(language)}`}
        style={{ borderColor: colors.secondaryLight }}
      />
    </div>
  );
};

export { Language_Text_Editor };
